import React, { useEffect, useState } from "react";
import { ReactComponent as DashboardIcon } from "assets/img/icons/dashboard_2.svg";
import { ReactComponent as TeamIcon } from "assets/img/icons/team_d.svg";
import { ReactComponent as TextIcon } from "assets/img/icons/text.svg";
import { ReactComponent as TimelineIcon } from "assets/img/icons/timeline.svg";
import { ReactComponent as WallofFameIcon } from "assets/img/icons/walloffame.svg";
import { ReactComponent as BrightIdeaIcon } from "assets/img/icons/brightideas.svg";
import { ReactComponent as CheckInIcon } from "assets/img/icons/smile-filled.svg";
import { ReactComponent as VideoIcon } from "assets/img/icons/video-camera-icon.svg";
import { ReactComponent as TrainingVideoIcon } from "assets/img/icons/document-icon.svg";
import { ReactComponent as SlideShowIcon } from "assets/img/icons/slideshow.svg";
import { ReactComponent as List } from "assets/img/icons/list.svg";
import { ReactComponent as TeamInformation } from "assets/img/icons/teaminfo.svg";
import { ReactComponent as Logout } from "assets/img/icons/logout.svg";
import { ReactComponent as Settings } from "assets/img/icons/settings.svg";
import { ReactComponent as WaterCooler } from "assets/img/icons/watercooler.svg";
import { ReactComponent as FaqIcon } from "assets/img/icons/faq.svg";
import { ReactComponent as Poll } from "assets/img/icons/Create_Poll_Menu.svg";
import { ReactComponent as Lock } from "assets/img/icons/lock.svg";
import { ReactComponent as ChatIcon } from "assets/img/icons/chat.svg";
import { ReactComponent as ListIcon } from "assets/img/icons/postListTask.svg";
import { ReactComponent as ListItemIcon } from "assets/img/icons/ic_task.svg";
import { ReactComponent as InfoIcon } from "assets/img/icons/info.svg";
import { ReactComponent as WellnessIcon } from "assets/img/lotus.svg";
import { ReactComponent as SurveyIcon } from "assets/img/survey_icon.svg";
import { ReactComponent as InnovationIcon } from "assets/img/icons/innovation-vista.svg";
import { ReactComponent as TriviaIcon } from "assets/img/icons/post-trivia.svg";
import { ReactComponent as CourseBuilderIcon } from "assets/img/icons/chalkboard-user.svg";
import { ReactComponent as TakeCourseIcon } from "assets/img/icons/book-open-solid.svg";
import { ReactComponent as GrowthPartnerCourseIcon } from "assets/img/icons/users-rectangle-solid.svg";

export default ({
  color = null,
  icon,
  imageclass,
  iconHeight,
  watercooler_private,
}) => {
  const [fill, setFill] = useState(undefined);

  const iconMapping = {
    Timeline: TimelineIcon,
    Dashboard: DashboardIcon,
    ListIcon: List,
    Team: TeamIcon,
    article: TextIcon,
    celebration: WallofFameIcon,
    brightidea: BrightIdeaIcon,
    checkin: CheckInIcon,
    teamvideo: VideoIcon,
    meeting: VideoIcon,
    doc: TrainingVideoIcon,
    slideshow: SlideShowIcon,
    GroupIcon: TeamInformation,
    watercooler: !watercooler_private ? WaterCooler : Lock,
    Logout: Logout,
    Setting: Settings,
    FAQ: FaqIcon,
    poll: Poll,
    "todo-list": ListIcon,
    "todo-list-item": ListItemIcon,
    coursebuilder: CourseBuilderIcon,
    takecourse: TakeCourseIcon,
    coursecreation: CourseBuilderIcon,
    growthpartnercourse: GrowthPartnerCourseIcon,
    Poll: Poll,
    Chat: ChatIcon,
    overview: InfoIcon,
    wellness: WellnessIcon,
    survey: SurveyIcon,
    innovation: InnovationIcon,
    trivia: TriviaIcon,
  };

  const PostTypeIcon = iconMapping[icon] || null;

  useEffect(() => {
    checkAvatarColor(color);
    //eslint-disable-next-line
  }, []);

  const checkAvatarColor = (color) => {
    if (color) {
      setFill(color === "white" ? "#575f6b" : "white");
    }
  };

  return (
    PostTypeIcon && (
      <PostTypeIcon
        style={{ fill: fill, height: iconHeight }}
        className={imageclass}
      />
    )
  );
};
